import axios from 'axios';
import config from '../config';

export const initSync = async (date, continueQueries) => {
  const { dataUrl, dataApiKey } = config || {};
  const data = {};
  if (date) {
    data.date = date;
  }
  if (continueQueries) {
    data.continueQueries = continueQueries;
  }
  return axios({
    method: 'POST',
    url: `${dataUrl}/sync`,
    data,
    headers: {
      'X-API-KEY': dataApiKey,
    },
    validateStatus: () => true, // do not throw errors on status >= 400
  }).then((resp) => resp.data);
};

export default { initSync };
